import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import PrivateRoute from './PrivateRoute';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import Vendite from './pages/Vendite';
import AnalisiMercato from './pages/AnalisiMercato';
import Profilo from './pages/Profilo';
import CreaAnnuncio from './pages/CreaAnnuncio';
import BozzeLegacy from './pages/Bozze';
import BozzePage from './pages/BozzePage';
import GestioneEbay from './pages/GestioneEbay';
import GestioneVinted from './pages/GestioneVinted';
import Annunci from './pages/Annunci';
import EbayCallback from './pages/EbayCallback';
import AuthCallback from './pages/AuthCallback';
import Corso from './pages/Corso';
import AdminCorso from './pages/AdminCorso';
import Admin from './pages/Admin';
import GuidePage from './pages/GuidePage';
import FornitoriPage from './pages/FornitoriPage';
import BestProductPage from './pages/BestProductPage';
import CollaboratorePage from './pages/CollaboratorePage';
import AuthCallbackCollab from './pages/AuthCallbackCollab';
import NotFound from './pages/NotFound';
import Guida from './pages/Guida';
import Abbonamento from './pages/Abbonamento';
import ChatAssistente from './components/ChatAssistente';
import ProGate from './components/ProGate';
import UpdateBanner from './components/UpdateBanner';
import ErrorBoundary from './components/ErrorBoundary';

function App() {
  // Cleanup JWT scaduti/malformati al boot (Fase 3 audit sicurezza 19/05/2026)
  useEffect(() => {
    const keys = ['token', 'impero_jwt_token'];
    keys.forEach((key) => {
      const tok = localStorage.getItem(key);
      if (!tok) return;
      try {
        const payload = JSON.parse(atob(tok.split('.')[1]));
        if (payload.exp && payload.exp * 1000 < Date.now()) {
          console.log(`[JWT cleanup] Rimosso ${key} (scaduto ${new Date(payload.exp * 1000).toISOString()})`);
          localStorage.removeItem(key);
        }
      } catch (e) {
        console.log(`[JWT cleanup] Rimosso ${key} (malformato)`);
        localStorage.removeItem(key);
      }
    });
  }, []); // solo al primo render

  return (
    <ErrorBoundary>
    <AuthProvider>
      <UpdateBanner />
      <BrowserRouter>
        <Routes>
          {/* Pubbliche — NON dentro PrivateRoute */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/auth/callback-collab" element={<AuthCallbackCollab />} />

          {/* Protette */}
          <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/products" element={<PrivateRoute><Products /></PrivateRoute>} />
          <Route path="/products/:id" element={<PrivateRoute><ProductDetail /></PrivateRoute>} />
          <Route path="/vendite" element={<PrivateRoute><Vendite /></PrivateRoute>} />
          <Route path="/analisi-mercato" element={<PrivateRoute><ProGate feature="Analisi Mercato AI"><AnalisiMercato /></ProGate></PrivateRoute>} />
          <Route path="/profilo" element={<PrivateRoute><Profilo /></PrivateRoute>} />
          <Route path="/annunci/crea" element={<PrivateRoute><ProGate feature="Annunci AI"><CreaAnnuncio /></ProGate></PrivateRoute>} />
          <Route path="/annunci/bozze" element={<PrivateRoute><ProGate feature="Bozze Annunci"><BozzeLegacy /></ProGate></PrivateRoute>} />
          <Route path="/bozze" element={<PrivateRoute><ProGate feature="Bozze e Editor Foto"><BozzePage /></ProGate></PrivateRoute>} />
          <Route path="/annunci" element={<PrivateRoute><Annunci /></PrivateRoute>} />
          <Route path="/annunci/ebay" element={<PrivateRoute><GestioneEbay /></PrivateRoute>} />
          <Route path="/annunci/vinted" element={<PrivateRoute><GestioneVinted /></PrivateRoute>} />
          <Route path="/ebay-callback" element={<PrivateRoute><EbayCallback /></PrivateRoute>} />
          <Route path="/corso" element={<PrivateRoute><Corso /></PrivateRoute>} />
          <Route path="/admin/corso" element={<PrivateRoute requiredRole="admin"><AdminCorso /></PrivateRoute>} />
          <Route path="/admin" element={<PrivateRoute><Admin /></PrivateRoute>} />
          <Route path="/guide" element={<PrivateRoute><GuidePage /></PrivateRoute>} />
          <Route path="/fornitori" element={<PrivateRoute><FornitoriPage /></PrivateRoute>} />
          <Route path="/best-products" element={<PrivateRoute><ProGate feature="Best Product"><BestProductPage /></ProGate></PrivateRoute>} />
          <Route path="/guida" element={<PrivateRoute><Guida /></PrivateRoute>} />
          <Route path="/abbonamento" element={<PrivateRoute><Abbonamento /></PrivateRoute>} />
          <Route path="/collaboratore" element={<PrivateRoute requiredRole="collaboratore"><CollaboratorePage /></PrivateRoute>} />

          {/* Default */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <ChatAssistente />
      </BrowserRouter>
    </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
